import { render, staticRenderFns } from "./ServiceComponentModelTable.vue?vue&type=template&id=5ce239e5&scoped=true&"
import script from "./ServiceComponentModelTable.vue?vue&type=script&lang=js&"
export * from "./ServiceComponentModelTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComponentModelTable.vue?vue&type=style&index=0&id=5ce239e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce239e5",
  null
  
)

export default component.exports